
<template>
  <div
    class="container"
  >
    <nav class="uk-navbar">
      <div
        class="img-header home-div"
      >
        <div
          style="cursor:pointer;"
          class="uk-flex"
        >
          <img
            src="../assets/img/Home.png"
            class="home"
            @click="goHome"
          >
        </div>
      </div>
      <div class="uk-flex icon-div">
        <font-awesome-icon
          class="icon-back"
          icon="arrow-left"
          @click="goHome"
        />
      </div>
      <div
        class="img-header img1-div"
      >
        <div class="uk-flex">
          <a
            class="uk-float-left link-image"
            href="#"
          >
            <img
              src="../assets/img/logo/only-logo.jpg"
              class="img1 uk-float-left"
              @click="goHome"
            >
          </a>
        </div>
      </div>
      <div class="uk-flex">
        <div
          class="img-header img2-div uk-flex "
        >
          <img
            src="../assets/img/presidencial.png"
            class="img2"
          >
        </div>
        <div
          class="img-header img3-div uk-flex"
        >
          <img
            src="../assets/img/header-logo-observatory-national.jpg"
            class="img3"
          >
        </div>
      </div>
    </nav>
    <hr class="hr-header">
  </div>
</template>

<script>
export default {
  name: 'AppHeader',
  methods: {
    goHome () {
      this.$store.dispatch('resetCosts')
      this.$router.push({ name: 'Home' })
      this.$windowPlugin.scrollToTop()
    },
    pushPage (name) {
      this.$store.dispatch('resetCosts')
      this.$router.push({ name })
      this.$windowPlugin.scrollToTop()
    }
  }
}
</script>

<style scoped>
.container{
  margin-top: 8px;
  /* width: 100%; */

}
.icon-div{
  display: none
}
.uk-navbar{
  display: flex;
  justify-content: space-between;
  background-color: #fff;
}

.title-logo{
  color: #3f3e40;
  margin-left: 10px
}

.hr-header {
  box-shadow: 0px 0px 0px rgb(131, 132, 143);
  margin: 10px 0px;
}
.img1 {
  width: 154px;
}

.img1-div{
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 120px ;
}

.img2-div{
  margin: 0px 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.img3-div{
   display: flex;
  flex-direction: column;
  justify-content: center;
}
.home-div{
  padding: 0px 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.home-div img{
  width: 50px;
}
.img2 {
  width: 130px;
}
.img3 {
  width: 140px;
  height: 40px;

}

.home{
  width: 70px;
}
.home:hover {
  font-size: 30px;
  color: rgb(40, 170, 22) !important;
  box-shadow: 0px 3px 16px rgb(16, 113, 155);
  transition: all 0.2s ease;
}

@media screen and (max-width: 880px){
.img1-div {
  width:60%;
  padding-left: 0px;
}
  .img1 {
  width: 110px;
}
.img2 {
  width: 130px;
}
.img3 {
  width: 140px;
}
.home-div{
  display: none;
}
}

@media screen and (max-width: 680px){

.img1-div {
  width:60%;
  padding-left: 0px;
}
.img2-div {
  width: 60%;
}
.img3-div {
  width: 60%
}
/* .home-div{
  display: none;
  width: 60%;
  height: 40%;
  max-height: 10px;
} */

}

@media screen and (max-width: 450px){
  .img1-div {
  width:50%;
  margin: 0px auto;
  min-width: 180px;
}
.img2-div {
  display: none;
}
.img3-div {
  display: none;
}
.link-image{
  margin: 0px 58px 0px 43px;
  display: inline-block;
}
.icon-div{
  display: flex;
    flex-direction: column;
    justify-content: center;
    width: 7%;
    min-width: 16px;
    padding: 0px 0px 0px 10px;

}
}
</style>
